import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { imageLoader } from '../../context/utils'
import { IMedia } from '../../interfaces/media'

interface IMagazineProps {
  issueLink: string
  issueCover: IMedia
}

const Magazine: React.FC<IMagazineProps> = ({ issueLink, issueCover }) => {
  const ref = useRef<HTMLIFrameElement>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const handleClick = () => {
    if (ref.current) {
      ref.current.requestFullscreen()
      setIsOpen(true)
    }
  }

  useEffect(() => {
    const { current } = ref
    const handleDisplay = (e: Event) => {
      if (!document.fullscreenElement) {
        setIsOpen(false)
      }
    }
    if (current) {
      current.addEventListener('fullscreenchange', handleDisplay)
    }
    return () => {
      if (current) {
        current.removeEventListener('fullscreenchange', handleDisplay)
      }
    }
  })

  return (
    <div className='h-full'>
      <div className='relative flex flex-col h-full items-center justify-center'>
        <div
          className='h-magazine-cover md:rotate-6 w-full drop-shadow-2xl relative 2xl:absolute 2xl:-top-[80px] cursor-pointer'
          onClick={handleClick}
        >
          {issueCover && (
            <Image
              tabIndex={0}
              loader={imageLoader}
              alt='BP 18 magazin'
              title='BP 18 magazin'
              src={issueCover.fileUrl}
              layout='fill'
              objectFit='scale-down'
            />
          )}
        </div>
        <p className='font-montserrat font-semibold text-footer-text-2xl 2xl:absolute bottom-20 mt-3 mb-3'>
          BP18 Magazin
        </p>
      </div>
      <div style={{ display: isOpen ? 'block' : 'none' }}>
        <iframe
          ref={ref}
          allow='clipboard-write'
          sandbox='allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox'
          allowFullScreen={true}
          src={issueLink}
        ></iframe>
      </div>
    </div>
  )
}

export default Magazine
